import WarrantyModule from '~/lib/vue/modules/document/warranty';

export default (services, namespace='warranties') => {
  return WarrantyModule.create({
    namespace,
    services,
  });
};

